import { createContext } from 'react';

import type { CalendarPeriod } from './calendarPeriods';

type CalendarViewContextValue = {
  openPeriodView: (
    period: CalendarPeriod,
    anchor: Date,
    trigger: HTMLElement
  ) => void;
};

export const CalendarViewContext = createContext<CalendarViewContextValue | null>(
  null
);
